import { Button } from "@mui/material";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { useTranslation } from "react-i18next";
import { DELETECANCEL, NONE, OK, OKCANCEL } from "../../Utils/GlobalValues";
import styles from "./Modal.module.css";
import { StyledDialog } from "./StyledDialog";

// properties that is to be added
// isModalOpen - Modal open or not
// setIsModalOpen - to change the state ofn the modal
// businessProcess - Additional business functionalities , non mandatory
// modalWidth - width of the screen , if not provided it is sm
// title - Title of the screen , if not provided it is "Alert"
// type - Can be Ok , Ok Cancel or Delete Cancel

function AlertModal(props) {
  const { t } = useTranslation("common");
  const handleSuccess = (event, reason) => {
    event.stopPropagation();
    // when we have clicked outside the modal the screen should not close
    if (reason && reason == "backdropClick") return;

    // call the additional methods also if present
    if (props.businessProcess != null && props.businessProcess != undefined) {
      props.businessProcess(props.data);
    }
    // set close state as false , to close the dialog
    props.setIsModalOpen(false);
  };

  const handleClose = (event, reason) => {
    event.stopPropagation();
    // when we have clicked outside the modal the screen should not close
    if (reason && reason == "backdropClick") return;

    // set close state as false , to close the dialog
    props.setIsModalOpen(false);

    // call the additional methods also if present
    if (props.onTacClose) {
      props.onTacClose();
    }
  };

  // if the modal width is not provided sm is taken as the width else modal width is returned as width
  // widths that can be provided are xs, sm, md, lg , xl
  const getModalWidth = () => {
    if (props.modalWidth != null && props.modalWidth != undefined) {
      return props.modalWidth;
    } else {
      return "sm";
    }
  };

  console.log("modalPaperClassName:;", props.modalPaperClassName);

  return (
    <>
      {/* Dialog window which has open property to indicate if screen is open or not,
            on close function , actions to be handled on close
       */}

      <StyledDialog
        open={props.isModalOpen}
        onClose={(event) => handleClose(event, "backdropClick")}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth={getModalWidth()}
        className={props.modalPaperClassName}
        {...(props.zindex && { zindex: props.zindex })}
        // BackdropProps={{
        //   invisible: true,
        // }}
        // disableEnforceFocus={true}
        // disableAutoFocus
        // keepMounted
        // hideBackdrop={false}
        // disableScrollLock
        disablePortal
      >
        {/* Title will be provided in props , if not provided "Alert" will be shown as the title
         */}
        <div className={props.theme ? styles.theme : props.className}>
          {props.title != null && props.title != undefined && (
            <DialogTitle className={styles.modaltitle} id="alert-dialog-title">
              {t(props.title)}
            </DialogTitle>
          )}

          {/* All the content of the dialog will be displayed here */}
          <DialogContent className={styles.modalcontent} sx={{ mt: 2 }}>
            {props.children}
          </DialogContent>

          {/* All the actions ok , cancel and delete will be taken here
           */}
          {props.type !== NONE && (
            <DialogActions className={props.modalfooter || styles.modalfooter}>
              {(props.type == DELETECANCEL || props.type == OKCANCEL) && (
                <Button
                  className="btn shadow-none cancel_btn cursor_pointer"
                  onClick={(event) => handleClose(event, "click")}
                >
                  {t("modal.cancel")}
                </Button>
              )}
              {(props.type == OK || props.type == OKCANCEL) && (
                <Button
                  className="btn shadow-none ok_btn cursor_pointer"
                  onClick={(event) => handleSuccess(event, "click")}
                >
                  {t("modal.ok")}
                </Button>
              )}
              {props.type == DELETECANCEL && (
                <Button
                  className="btn shadow-none delete_btn cursor_pointer"
                  onClick={(event) => handleSuccess(event, "click")}
                >
                  {t("modal.delete")}
                </Button>
              )}
            </DialogActions>
          )}
        </div>
      </StyledDialog>
    </>
  );
}

export default AlertModal;
